<p-confirmDialog key="facility" [style]="{ width: '400px' }" [baseZIndex]="10000"></p-confirmDialog>

<!--General Information-->
<div class="ItemBorder">
	<div class="MainGrid2Col">
		<label>Select Facility:</label>

		<select
			[disabled]="IsLoading() == true"
			class="form-control"
			name="SelectedFacility"
			[(ngModel)]="SelectedFacility"
			(ngModelChange)="onFacilityChange($event)"
		>
			<option value="" style="display: none"></option>
			<option *ngFor="let o of lstFacility" [ngValue]="o">{{ o.Desc }}</option>
		</select>
	</div>

	<!-------------------------------------------------------------------------------------------------------------------------->
	<div class="Divider"></div>
	<!-------------------------------------------------------------------------------------------------------------------------->

	<h4>
		Facility Settings - <span class="InfoText">{{ SelectedFacility?.Desc }}</span>
	</h4>

	<!--Option Grid-->
	<div class="MainGrid2Col">
		<label>Settings Last Updated:</label>
		<label class="InfoText">{{ c_DateDesc }}</label>
	</div>

	<!-------------------------------------------------------------------------------------------------------------------------->
	<div *ngIf="IsSU == true" class="Divider"></div>
	<!-------------------------------------------------------------------------------------------------------------------------->

	<h4 *ngIf="IsSU == true" class="TopMargin">
		Access411 Settings - <span class="InfoText">{{ SelectedFacility?.Desc }}</span> (SU-Only)
	</h4>
	<div *ngIf="IsSU == true">
		<p class="InstructionText">
			Note: Turning off scanning modes will disable them for the whole district. If they are allowed the district can choose to use them or disable them.
		</p>
	</div>
	<div *ngIf="IsSU == true" class="MainGrid2Col">
		<label for="A411_Facility_VisitorModeEnabled">Visitor Mode Allowed:</label>
		<input
			[disabled]="IsLoading() == true || A411_District_VisitorModeEnabled == false"
			type="checkbox"
			class="CHK"
			[(ngModel)]="A411_Facility_VisitorModeEnabled"
			id="A411_Facility_VisitorModeEnabled"
			name="A411_Facility_VisitorModeEnabled"
		/>

		<label for="A411_Facility_StudentModeEnabled">Student Mode Allowed:</label>
		<input
			[disabled]="IsLoading() == true || A411_District_StudentModeEnabled == false"
			type="checkbox"
			class="CHK"
			[(ngModel)]="A411_Facility_StudentModeEnabled"
			id="A411_Facility_StudentModeEnabled"
			name="A411_Facility_StudentModeEnabled"
		/>

		<label for="A411_Facility_StaffModeEnabled">Staff Mode Allowed:</label>
		<input
			[disabled]="IsLoading() == true || A411_District_StaffModeEnabled == false"
			type="checkbox"
			class="CHK"
			[(ngModel)]="A411_Facility_StaffModeEnabled"
			id="A411_Facility_StaffModeEnabled"
			name="A411_Facility_StaffModeEnabled"
		/>

		<label for="A411_Facility_OffenderLookupEnabled">Offender Lookup Allowed:</label>
		<input
			[disabled]="IsLoading() == true || A411_District_OffenderLookupEnabled == false"
			type="checkbox"
			class="CHK"
			[(ngModel)]="A411_Facility_OffenderLookupEnabled"
			id="A411_Facility_OffenderLookupEnabled"
			name="A411_Facility_OffenderLookupEnabled"
		/>
	</div>
</div>

<!--Options-->
<div class="ItemBorder TopMargin">
	<h4>Scanning Modes</h4>
	<div class="MainGrid2Col">
		<label for="VisitorModeEnabled">Visitor Mode Enabled:</label>
		<div class="ButtonGrid">
			<input
				*ngIf="A411_District_VisitorModeEnabled == true && A411_Facility_VisitorModeEnabled == true"
				[disabled]="IsLoading() == true || District_VisitorModeCanOverride == false"
				type="checkbox"
				class="CHK"
				[(ngModel)]="VisitorModeEnabled"
				id="VisitorModeEnabled"
				name="VisitorModeEnabled"
			/>
			<button
				*ngIf="VisitorModeCanOverride == true && A411_District_VisitorModeEnabled == true && A411_Facility_VisitorModeEnabled == true"
				[disabled]="IsLoading() == true || District_VisitorModeCanOverride == false"
				class="btn btn-success NoMargin LockButtonWidth"
				(click)="onToggleVisitorModeCanOverride()"
			>
				<i class="fa fa-unlock" aria-hidden="true"></i>
			</button>
			<button
				*ngIf="VisitorModeCanOverride == false && A411_District_VisitorModeEnabled == true && A411_Facility_VisitorModeEnabled == true"
				[disabled]="IsLoading() == true || District_VisitorModeCanOverride == false"
				class="btn btn-danger NoMargin LockButtonWidth"
				(click)="onToggleVisitorModeCanOverride()"
			>
				<i class="fa fa-lock" aria-hidden="true"></i>
			</button>

			<label *ngIf="A411_District_VisitorModeEnabled == false || A411_Facility_VisitorModeEnabled == false" class="A411DisabledText"
				>Disabled by Access411</label
			>
			<label
				*ngIf="A411_District_VisitorModeEnabled == true && A411_Facility_VisitorModeEnabled == true && District_VisitorModeCanOverride == false"
				class="A411DisabledText"
				>Locked by District</label
			>
		</div>

		<label for="StudentModeEnabled">Student Mode Enabled:</label>
		<div class="ButtonGrid">
			<input
				*ngIf="A411_District_StudentModeEnabled == true && A411_Facility_StudentModeEnabled == true"
				[disabled]="IsLoading() == true || District_StudentModeCanOverride == false"
				type="checkbox"
				class="CHK"
				[(ngModel)]="StudentModeEnabled"
				id="StudentModeEnabled"
				name="VisitorModeEnabled"
			/>
			<button
				*ngIf="StudentModeCanOverride == true && A411_District_StudentModeEnabled == true && A411_Facility_StudentModeEnabled == true"
				[disabled]="IsLoading() == true || District_StudentModeCanOverride == false"
				class="btn btn-success NoMargin LockButtonWidth"
				(click)="onToggleStudentModeCanOverride()"
			>
				<i class="fa fa-unlock" aria-hidden="true"></i>
			</button>
			<button
				*ngIf="StudentModeCanOverride == false && A411_District_StudentModeEnabled == true && A411_Facility_StudentModeEnabled == true"
				[disabled]="IsLoading() == true || District_StudentModeCanOverride == false"
				class="btn btn-danger NoMargin LockButtonWidth"
				(click)="onToggleStudentModeCanOverride()"
			>
				<i class="fa fa-lock" aria-hidden="true"></i>
			</button>

			<label *ngIf="A411_District_StudentModeEnabled == false || A411_Facility_StudentModeEnabled == false" class="A411DisabledText"
				>Disabled by Access411</label
			>
			<label
				*ngIf="A411_District_VisitorModeEnabled == true && A411_Facility_VisitorModeEnabled == true && District_StudentModeCanOverride == false"
				class="A411DisabledText"
				>Locked by District</label
			>
		</div>

		<label for="StaffModeEnabled">Staff Mode Enabled:</label>
		<div class="ButtonGrid">
			<input
				*ngIf="A411_District_StaffModeEnabled == true && A411_Facility_StaffModeEnabled == true"
				[disabled]="IsLoading() == true || District_StaffModeCanOverride == false"
				type="checkbox"
				class="CHK"
				[(ngModel)]="StaffModeEnabled"
				id="StaffModeEnabled"
				name="VisitorModeEnabled"
			/>

			<button
				*ngIf="StaffModeCanOverride == true && A411_District_StaffModeEnabled == true && A411_Facility_StaffModeEnabled == true"
				[disabled]="IsLoading() == true || District_StaffModeCanOverride == false"
				class="btn btn-success NoMargin LockButtonWidth"
				(click)="onToggleStaffModeCanOverride()"
			>
				<i class="fa fa-unlock" aria-hidden="true"></i>
			</button>
			<button
				*ngIf="StaffModeCanOverride == false && A411_District_StaffModeEnabled == true && A411_Facility_StaffModeEnabled == true"
				[disabled]="IsLoading() == true || District_StaffModeCanOverride == false"
				class="btn btn-danger NoMargin LockButtonWidth"
				(click)="onToggleStaffModeCanOverride()"
			>
				<i class="fa fa-lock" aria-hidden="true"></i>
			</button>

			<label *ngIf="A411_District_StaffModeEnabled == false || A411_Facility_StaffModeEnabled == false" class="A411DisabledText"
				>Disabled by Access411</label
			>
			<label
				*ngIf="A411_District_VisitorModeEnabled == true && A411_Facility_VisitorModeEnabled == true && District_StaffModeCanOverride == false"
				class="A411DisabledText"
				>Locked by District</label
			>
		</div>

		<label for="OffenderLookupEnabled">Offender Lookup Enabled:</label>
		<div class="ButtonGrid">
			<input
				*ngIf="A411_District_OffenderLookupEnabled == true && A411_Facility_OffenderLookupEnabled == true"
				[disabled]="IsLoading() == true || District_OffenderLookupCanOverride == false"
				type="checkbox"
				class="CHK"
				[(ngModel)]="OffenderLookupEnabled"
				id="OffenderLookupEnabled"
				name="VisitorModeEnabled"
			/>

			<button
				*ngIf="OffenderLookupCanOverride == true && A411_District_OffenderLookupEnabled == true && A411_Facility_OffenderLookupEnabled == true"
				[disabled]="IsLoading() == true || District_OffenderLookupCanOverride == false"
				class="btn btn-success NoMargin LockButtonWidth"
				(click)="onToggleOffenderLookupCanOverride()"
			>
				<i class="fa fa-unlock" aria-hidden="true"></i>
			</button>
			<button
				*ngIf="OffenderLookupCanOverride == false && A411_District_OffenderLookupEnabled == true && A411_Facility_OffenderLookupEnabled == true"
				[disabled]="IsLoading() == true || District_OffenderLookupCanOverride == false"
				class="btn btn-danger NoMargin LockButtonWidth"
				(click)="onToggleOffenderLookupCanOverride()"
			>
				<i class="fa fa-lock" aria-hidden="true"></i>
			</button>

			<label *ngIf="A411_District_OffenderLookupEnabled == false || A411_Facility_OffenderLookupEnabled == false" class="A411DisabledText"
				>Disabled by Access411</label
			>
			<label
				*ngIf="A411_District_VisitorModeEnabled == true && A411_Facility_VisitorModeEnabled == true && District_OffenderLookupCanOverride == false"
				class="A411DisabledText"
				>Locked by District</label
			>
		</div>
	</div>

	<!-------------------------------------------------------------------------------------------------------------------------->
	<div class="Divider"></div>
	<!-------------------------------------------------------------------------------------------------------------------------->

	<!--xxx-->

	<h4 class="TopMargin">Check-In Steps</h4>
	<div class="MainGrid2Col">
		<label for="PhotoRequired">Photo Required:</label>
		<div class="ButtonGrid">
			<input
				[disabled]="IsLoading() == true || District_PhotoRequiredCanOverride == false"
				type="checkbox"
				class="CHK"
				[(ngModel)]="PhotoRequired"
				id="PhotoRequired"
				name="PhotoRequired"
			/>
			<button
				*ngIf="PhotoRequiredCanOverride == true"
				[disabled]="IsLoading() == true || District_PhotoRequiredCanOverride == false"
				class="btn btn-success NoMargin LockButtonWidth"
				(click)="onTogglePhotoRequiredCanOverride()"
			>
				<i class="fa fa-unlock" aria-hidden="true"></i>
			</button>
			<button
				*ngIf="PhotoRequiredCanOverride == false"
				[disabled]="IsLoading() == true || District_PhotoRequiredCanOverride == false"
				class="btn btn-danger NoMargin LockButtonWidth"
				(click)="onTogglePhotoRequiredCanOverride()"
			>
				<i class="fa fa-lock" aria-hidden="true"></i>
			</button>
			<label *ngIf="District_PhotoRequiredCanOverride == false" class="A411DisabledText">Locked by District</label>
		</div>

		<div class="OptionLabelDiv">
			<label for="SkipPhotoIfNotRequired">Skip Photo Page if not Required:</label>
			<label for="SkipPhotoIfNotRequired" class="ExtraLabelText">(Automatically use driver's license photo or existing photo)</label>
		</div>
		<div class="ButtonGrid">
			<input
				[disabled]="IsLoading() == true || District_SkipPhotoIfNotRequiredCanOverride == false"
				type="checkbox"
				class="CHK"
				[(ngModel)]="SkipPhotoIfNotRequired"
				id="SkipPhotoIfNotRequired"
				name="SkipPhotoIfNotRequired"
			/>
			<button
				*ngIf="SkipPhotoIfNotRequiredCanOverride == true"
				[disabled]="IsLoading() == true || District_SkipPhotoIfNotRequiredCanOverride == false"
				class="btn btn-success NoMargin LockButtonWidth"
				(click)="onToggleSkipPhotoIfNotRequiredCanOverride()"
			>
				<i class="fa fa-unlock" aria-hidden="true"></i>
			</button>
			<button
				*ngIf="SkipPhotoIfNotRequiredCanOverride == false"
				[disabled]="IsLoading() == true || District_SkipPhotoIfNotRequiredCanOverride == false"
				class="btn btn-danger NoMargin LockButtonWidth"
				(click)="onToggleSkipPhotoIfNotRequiredCanOverride()"
			>
				<i class="fa fa-lock" aria-hidden="true"></i>
			</button>
			<label *ngIf="District_SkipPhotoIfNotRequiredCanOverride == false" class="A411DisabledText">Locked by District</label>
		</div>

		<label for="UseDriversLicensePhoto">Use Driver's License Photo:</label>
		<div class="ButtonGrid">
			<input
				[disabled]="IsLoading() == true || District_UseDriversLicensePhotoCanOverride == false"
				type="checkbox"
				class="CHK"
				[(ngModel)]="UseDriversLicensePhoto"
				id="UseDriversLicensePhoto"
				name="UseDriversLicensePhoto"
			/>
			<button
				*ngIf="UseDriversLicensePhotoCanOverride == true"
				[disabled]="IsLoading() == true || District_UseDriversLicensePhotoCanOverride == false"
				class="btn btn-success NoMargin LockButtonWidth"
				(click)="onToggleUseDriversLicensePhotoCanOverride()"
			>
				<i class="fa fa-unlock" aria-hidden="true"></i>
			</button>
			<button
				*ngIf="UseDriversLicensePhotoCanOverride == false"
				[disabled]="IsLoading() == true || District_UseDriversLicensePhotoCanOverride == false"
				class="btn btn-danger NoMargin LockButtonWidth"
				(click)="onToggleUseDriversLicensePhotoCanOverride()"
			>
				<i class="fa fa-lock" aria-hidden="true"></i>
			</button>
			<label *ngIf="District_UseDriversLicensePhotoCanOverride == false" class="A411DisabledText">Locked by District</label>
		</div>

		<label for="AllowExistingPhoto">Allow Existing Photo (From Previous Visit):</label>
		<div class="ButtonGrid">
			<input
				[disabled]="IsLoading() == true || District_AllowExistingPhotoCanOverride == false"
				type="checkbox"
				class="CHK"
				[(ngModel)]="AllowExistingPhoto"
				id="AllowExistingPhoto"
				name="AllowExistingPhoto"
			/>
			<button
				*ngIf="AllowExistingPhotoCanOverride == true"
				[disabled]="IsLoading() == true || District_AllowExistingPhotoCanOverride == false"
				class="btn btn-success NoMargin LockButtonWidth"
				(click)="onToggleAllowExistingPhotoCanOverride()"
			>
				<i class="fa fa-unlock" aria-hidden="true"></i>
			</button>
			<button
				*ngIf="AllowExistingPhotoCanOverride == false"
				[disabled]="IsLoading() == true || District_AllowExistingPhotoCanOverride == false"
				class="btn btn-danger NoMargin LockButtonWidth"
				(click)="onToggleAllowExistingPhotoCanOverride()"
			>
				<i class="fa fa-lock" aria-hidden="true"></i>
			</button>
			<label *ngIf="District_AllowExistingPhotoCanOverride == false" class="A411DisabledText">Locked by District</label>
		</div>

		<label>Re-take Existing Photo After X Days:</label>
		<div class="ButtonGrid">
			<input
				[disabled]="IsLoading() == true || District_ForceRetakePhotoCanOverride == false"
				type="number"
				class="form-control"
				[(ngModel)]="ForceRetakePhotoAfterXDays"
			/>
			<button
				*ngIf="ForceRetakePhotoCanOverride == true"
				[disabled]="IsLoading() == true || District_ForceRetakePhotoCanOverride == false"
				class="btn btn-success NoMargin LockButtonWidth"
				(click)="onToggleForceRetakePhotoCanOverride()"
			>
				<i class="fa fa-unlock" aria-hidden="true"></i>
			</button>
			<button
				*ngIf="ForceRetakePhotoCanOverride == false"
				[disabled]="IsLoading() == true || District_ForceRetakePhotoCanOverride == false"
				class="btn btn-danger NoMargin LockButtonWidth"
				(click)="onToggleForceRetakePhotoCanOverride()"
			>
				<i class="fa fa-lock" aria-hidden="true"></i>
			</button>
			<label *ngIf="District_ForceRetakePhotoCanOverride == false" class="A411DisabledText">Locked by District</label>
		</div>

		<label for="SkipConfirmInfo">Skip Confirm Info Page:</label>
		<div class="ButtonGrid">
			<input
				[disabled]="IsLoading() == true || District_SkipConfirmInfoCanOverride == false"
				type="checkbox"
				class="CHK"
				[(ngModel)]="SkipConfirmInfo"
				id="SkipConfirmInfo"
				name="SkipConfirmInfo"
			/>
			<button
				*ngIf="SkipConfirmInfoCanOverride == true"
				[disabled]="IsLoading() == true || District_SkipConfirmInfoCanOverride == false"
				class="btn btn-success NoMargin LockButtonWidth"
				(click)="onToggleSkipConfirmInfoCanOverride()"
			>
				<i class="fa fa-unlock" aria-hidden="true"></i>
			</button>
			<button
				*ngIf="SkipConfirmInfoCanOverride == false"
				[disabled]="IsLoading() == true || District_SkipConfirmInfoCanOverride == false"
				class="btn btn-danger NoMargin LockButtonWidth"
				(click)="onToggleSkipConfirmInfoCanOverride()"
			>
				<i class="fa fa-lock" aria-hidden="true"></i>
			</button>
			<label *ngIf="District_SkipConfirmInfoCanOverride == false" class="A411DisabledText">Locked by District</label>
		</div>

		<label for="SkipVisitorType">Skip Visitor Type Page:</label>
		<div class="ButtonGrid">
			<input
				[disabled]="IsLoading() == true || District_SkipVisitorTypeCanOverride == false"
				type="checkbox"
				class="CHK"
				[(ngModel)]="SkipVisitorType"
				id="SkipVisitorType"
				name="SkipVisitorType"
			/>
			<button
				*ngIf="SkipVisitorTypeCanOverride == true"
				[disabled]="IsLoading() == true || District_SkipVisitorTypeCanOverride == false"
				class="btn btn-success NoMargin LockButtonWidth"
				(click)="onToggleSkipVisitorTypeCanOverride()"
			>
				<i class="fa fa-unlock" aria-hidden="true"></i>
			</button>
			<button
				*ngIf="SkipVisitorTypeCanOverride == false"
				[disabled]="IsLoading() == true || District_SkipVisitorTypeCanOverride == false"
				class="btn btn-danger NoMargin LockButtonWidth"
				(click)="onToggleSkipVisitorTypeCanOverride()"
			>
				<i class="fa fa-lock" aria-hidden="true"></i>
			</button>
			<label *ngIf="District_SkipVisitorTypeCanOverride == false" class="A411DisabledText">Locked by District</label>
		</div>

		<label>Default Visitor Type (If you skip that page):</label>
		<div class="ButtonGrid">
			<select
				[disabled]="IsLoading() == true || District_DefaultVisitorTypeCanOverride == false"
				class="form-control"
				name="DefaultVisitorTypeID"
				[(ngModel)]="DefaultVisitorTypeID"
			>
				<option value="" style="display: none"></option>
				<option *ngFor="let o of lstVisitorType" [ngValue]="o.ID">{{ o.Desc }}</option>
			</select>
			<button
				*ngIf="DefaultVisitorTypeCanOverride == true"
				[disabled]="IsLoading() == true || District_DefaultVisitorTypeCanOverride == false"
				class="btn btn-success NoMargin LockButtonWidth"
				(click)="onToggleDefaultVisitorTypeCanOverride()"
			>
				<i class="fa fa-unlock" aria-hidden="true"></i>
			</button>
			<button
				*ngIf="DefaultVisitorTypeCanOverride == false"
				[disabled]="IsLoading() == true || District_DefaultVisitorTypeCanOverride == false"
				class="btn btn-danger NoMargin LockButtonWidth"
				(click)="onToggleDefaultVisitorTypeCanOverride()"
			>
				<i class="fa fa-lock" aria-hidden="true"></i>
			</button>
			<label *ngIf="District_DefaultVisitorTypeCanOverride == false" class="A411DisabledText">Locked by District</label>
		</div>

		<label for="SkipVisitee">Skip Visitee Page:</label>
		<div class="ButtonGrid">
			<input
				[disabled]="IsLoading() == true || District_SkipVisiteeCanOverride == false"
				type="checkbox"
				class="CHK"
				[(ngModel)]="SkipVisitee"
				id="SkipVisitee"
				name="SkipVisitee"
			/>
			<button
				*ngIf="SkipVisiteeCanOverride == true"
				[disabled]="IsLoading() == true || District_SkipVisiteeCanOverride == false"
				class="btn btn-success NoMargin LockButtonWidth"
				(click)="onToggleSkipVisiteeCanOverride()"
			>
				<i class="fa fa-unlock" aria-hidden="true"></i>
			</button>
			<button
				*ngIf="SkipVisiteeCanOverride == false"
				[disabled]="IsLoading() == true || District_SkipVisiteeCanOverride == false"
				class="btn btn-danger NoMargin LockButtonWidth"
				(click)="onToggleSkipVisiteeCanOverride()"
			>
				<i class="fa fa-lock" aria-hidden="true"></i>
			</button>
			<label *ngIf="District_SkipVisiteeCanOverride == false" class="A411DisabledText">Locked by District</label>
		</div>

		<label>Default Visitee (If you skip that page):</label>
		<div class="ButtonGrid">
			<select
				[disabled]="IsLoading() == true || District_DefaultVisiteeCanOverride == false"
				class="form-control"
				name="SelectedVisitee"
				[(ngModel)]="SelectedVisitee"
			>
				<option value="" style="display: none"></option>
				<option *ngFor="let o of lstVisitee" [ngValue]="o">{{ o.Desc }}</option>
			</select>
			<button
				*ngIf="DefaultVisiteeCanOverride == true"
				[disabled]="IsLoading() == true || District_DefaultVisiteeCanOverride == false"
				class="btn btn-success NoMargin LockButtonWidth"
				(click)="onToggleDefaultVisiteeCanOverride()"
			>
				<i class="fa fa-unlock" aria-hidden="true"></i>
			</button>
			<button
				*ngIf="DefaultVisiteeCanOverride == false"
				[disabled]="IsLoading() == true || District_DefaultVisiteeCanOverride == false"
				class="btn btn-danger NoMargin LockButtonWidth"
				(click)="onToggleDefaultVisiteeCanOverride()"
			>
				<i class="fa fa-lock" aria-hidden="true"></i>
			</button>
			<label *ngIf="District_DefaultVisiteeCanOverride == false" class="A411DisabledText">Locked by District</label>
		</div>

		<label for="SkipVisitReason">Skip Visit Reason Page:</label>
		<div class="ButtonGrid">
			<input
				[disabled]="IsLoading() == true || District_SkipVisitReasonCanOverride == false"
				type="checkbox"
				class="CHK"
				[(ngModel)]="SkipVisitReason"
				id="SkipVisitReason"
				name="SkipVisitReason"
			/>
			<button
				*ngIf="SkipVisitReasonCanOverride == true"
				[disabled]="IsLoading() == true || District_SkipVisitReasonCanOverride == false"
				class="btn btn-success NoMargin LockButtonWidth"
				(click)="onToggleSkipVisitReasonCanOverride()"
			>
				<i class="fa fa-unlock" aria-hidden="true"></i>
			</button>
			<button
				*ngIf="SkipVisitReasonCanOverride == false"
				[disabled]="IsLoading() == true || District_SkipVisitReasonCanOverride == false"
				class="btn btn-danger NoMargin LockButtonWidth"
				(click)="onToggleSkipVisitReasonCanOverride()"
			>
				<i class="fa fa-lock" aria-hidden="true"></i>
			</button>
			<label *ngIf="District_SkipVisitReasonCanOverride == false" class="A411DisabledText">Locked by District</label>
		</div>

		<label>Default Visit Reason (If you skip that page):</label>
		<div class="ButtonGrid">
			<select
				[disabled]="IsLoading() == true || District_DefaultVisitReasonCanOverride == false"
				class="form-control"
				name="DefaultVisitReasonID"
				[(ngModel)]="DefaultVisitReasonID"
			>
				<option value="" style="display: none"></option>
				<option *ngFor="let o of lstVisitReason" [ngValue]="o.ID">{{ o.Desc }}</option>
			</select>
			<button
				*ngIf="DefaultVisitReasonCanOverride == true"
				[disabled]="IsLoading() == true || District_DefaultVisitReasonCanOverride == false"
				class="btn btn-success NoMargin LockButtonWidth"
				(click)="onToggleDefaultVisitReasonCanOverride()"
			>
				<i class="fa fa-unlock" aria-hidden="true"></i>
			</button>
			<button
				*ngIf="DefaultVisitReasonCanOverride == false"
				[disabled]="IsLoading() == true || District_DefaultVisitReasonCanOverride == false"
				class="btn btn-danger NoMargin LockButtonWidth"
				(click)="onToggleDefaultVisitReasonCanOverride()"
			>
				<i class="fa fa-lock" aria-hidden="true"></i>
			</button>
			<label *ngIf="District_DefaultVisitReasonCanOverride == false" class="A411DisabledText">Locked by District</label>
		</div>

		<label for="SkipAdditionalNotes">Skip Additional Notes Page:</label>
		<div class="ButtonGrid">
			<input
				[disabled]="IsLoading() == true || District_SkipAdditionalNotesCanOverride == false"
				type="checkbox"
				class="CHK"
				[(ngModel)]="SkipAdditionalNotes"
				id="SkipAdditionalNotes"
				name="SkipAdditionalNotes"
			/>
			<button
				*ngIf="SkipAdditionalNotesCanOverride == true"
				[disabled]="IsLoading() == true || District_SkipAdditionalNotesCanOverride == false"
				class="btn btn-success NoMargin LockButtonWidth"
				(click)="onToggleSkipAdditionalNotesCanOverride()"
			>
				<i class="fa fa-unlock" aria-hidden="true"></i>
			</button>
			<button
				*ngIf="SkipAdditionalNotesCanOverride == false"
				[disabled]="IsLoading() == true || District_SkipAdditionalNotesCanOverride == false"
				class="btn btn-danger NoMargin LockButtonWidth"
				(click)="onToggleSkipAdditionalNotesCanOverride()"
			>
				<i class="fa fa-lock" aria-hidden="true"></i>
			</button>
			<label *ngIf="District_SkipAdditionalNotesCanOverride == false" class="A411DisabledText">Locked by District</label>
		</div>

		<label for="SkipSignature">Skip Signature Page:</label>
		<div class="ButtonGrid">
			<input
				[disabled]="IsLoading() == true || District_SkipSignatureCanOverride == false"
				type="checkbox"
				class="CHK"
				[(ngModel)]="SkipSignature"
				id="SkipSignature"
				name="SkipSignature"
			/>
			<button
				*ngIf="SkipSignatureCanOverride == true"
				[disabled]="IsLoading() == true || District_SkipSignatureCanOverride == false"
				class="btn btn-success NoMargin LockButtonWidth"
				(click)="onToggleSkipSignatureCanOverride()"
			>
				<i class="fa fa-unlock" aria-hidden="true"></i>
			</button>
			<button
				*ngIf="SkipSignatureCanOverride == false"
				[disabled]="IsLoading() == true || District_SkipSignatureCanOverride == false"
				class="btn btn-danger NoMargin LockButtonWidth"
				(click)="onToggleSkipSignatureCanOverride()"
			>
				<i class="fa fa-lock" aria-hidden="true"></i>
			</button>
			<label *ngIf="District_SkipSignatureCanOverride == false" class="A411DisabledText">Locked by District</label>
		</div>

		<label for="UseDriversLicenseSignature">Use Driver's License Signature:</label>
		<div class="ButtonGrid">
			<input
				[disabled]="IsLoading() == true || District_UseDriversLicenseSignatureCanOverride == false"
				type="checkbox"
				class="CHK"
				[(ngModel)]="UseDriversLicenseSignature"
				id="UseDriversLicenseSignature"
				name="UseDriversLicenseSignature"
			/>
			<button
				*ngIf="UseDriversLicenseSignatureCanOverride == true"
				[disabled]="IsLoading() == true || District_UseDriversLicenseSignatureCanOverride == false"
				class="btn btn-success NoMargin LockButtonWidth"
				(click)="onToggleUseDriversLicenseSignatureCanOverride()"
			>
				<i class="fa fa-unlock" aria-hidden="true"></i>
			</button>
			<button
				*ngIf="UseDriversLicenseSignatureCanOverride == false"
				[disabled]="IsLoading() == true || District_UseDriversLicenseSignatureCanOverride == false"
				class="btn btn-danger NoMargin LockButtonWidth"
				(click)="onToggleUseDriversLicenseSignatureCanOverride()"
			>
				<i class="fa fa-lock" aria-hidden="true"></i>
			</button>
			<label *ngIf="District_UseDriversLicenseSignatureCanOverride == false" class="A411DisabledText">Locked by District</label>
		</div>
	</div>

	<!-------------------------------------------------------------------------------------------------------------------------->
	<div class="Divider"></div>
	<!-------------------------------------------------------------------------------------------------------------------------->

	<h4 class="TopMargin">Printing Settings</h4>
	<div class="MainGrid2Col">
		<label>Default Visitor Pass:</label>
		<div class="ButtonGrid">
			<select
				[disabled]="IsLoading() == true || District_Template_DefaultCanOverride == false"
				class="form-control"
				name="Template_Default"
				[(ngModel)]="Template_Default"
			>
				<option value="" style="display: none"></option>
				<option *ngFor="let o of lstIDCardTemplate" [ngValue]="o.IDCardTemplateID">{{ o.CardName }}</option>
			</select>
			<button
				*ngIf="Template_DefaultCanOverride == true"
				[disabled]="IsLoading() == true || District_Template_DefaultCanOverride == false"
				class="btn btn-success NoMargin LockButtonWidth"
				(click)="onToggleTemplate_DefaultCanOverride()"
			>
				<i class="fa fa-unlock" aria-hidden="true"></i>
			</button>
			<button
				*ngIf="Template_DefaultCanOverride == false"
				[disabled]="IsLoading() == true || District_Template_DefaultCanOverride == false"
				class="btn btn-danger NoMargin LockButtonWidth"
				(click)="onToggleTemplate_DefaultCanOverride()"
			>
				<i class="fa fa-lock" aria-hidden="true"></i>
			</button>
			<label *ngIf="District_Template_DefaultCanOverride == false" class="A411DisabledText">Locked by District</label>
		</div>

		<label>Verification Required Visitor Pass:</label>
		<div class="ButtonGrid">
			<select
				[disabled]="IsLoading() == true || District_Template_VerificationReqdCanOverride == false"
				class="form-control"
				name="Template_VerificationReqd"
				[(ngModel)]="Template_VerificationReqd"
			>
				<option value="" style="display: none"></option>
				<option *ngFor="let o of lstIDCardTemplate" [ngValue]="o.IDCardTemplateID">{{ o.CardName }}</option>
			</select>
			<button
				*ngIf="Template_VerificationReqdCanOverride == true"
				[disabled]="IsLoading() == true || District_Template_VerificationReqdCanOverride == false"
				class="btn btn-success NoMargin LockButtonWidth"
				(click)="onToggleTemplate_VerificationReqdCanOverride()"
			>
				<i class="fa fa-unlock" aria-hidden="true"></i>
			</button>
			<button
				*ngIf="Template_VerificationReqdCanOverride == false"
				[disabled]="IsLoading() == true || District_Template_VerificationReqdCanOverride == false"
				class="btn btn-danger NoMargin LockButtonWidth"
				(click)="onToggleTemplate_VerificationReqdCanOverride()"
			>
				<i class="fa fa-lock" aria-hidden="true"></i>
			</button>
			<label *ngIf="District_Template_VerificationReqdCanOverride == false" class="A411DisabledText">Locked by District</label>
		</div>

		<label>Offender Hit Visitor Pass:</label>
		<div class="ButtonGrid">
			<select
				[disabled]="IsLoading() == true || District_Template_OffenderHitCanOverride == false"
				class="form-control"
				name="Template_OffenderHit"
				[(ngModel)]="Template_OffenderHit"
			>
				<option value="" style="display: none"></option>
				<option *ngFor="let o of lstIDCardTemplate" [ngValue]="o.IDCardTemplateID">{{ o.CardName }}</option>
			</select>
			<button
				*ngIf="Template_OffenderHitCanOverride == true"
				[disabled]="IsLoading() == true || District_Template_OffenderHitCanOverride == false"
				class="btn btn-success NoMargin LockButtonWidth"
				(click)="onToggleTemplate_OffenderHitCanOverride()"
			>
				<i class="fa fa-unlock" aria-hidden="true"></i>
			</button>
			<button
				*ngIf="Template_OffenderHitCanOverride == false"
				[disabled]="IsLoading() == true || District_Template_OffenderHitCanOverride == false"
				class="btn btn-danger NoMargin LockButtonWidth"
				(click)="onToggleTemplate_OffenderHitCanOverride()"
			>
				<i class="fa fa-lock" aria-hidden="true"></i>
			</button>
			<label *ngIf="District_Template_OffenderHitCanOverride == false" class="A411DisabledText">Locked by District</label>
		</div>

		<label for="PrintStudentLatePasses">Print Student Late Passes:</label>
		<div class="ButtonGrid">
			<input
				[disabled]="IsLoading() == true || District_PrintStudentLatePassesCanOverride == false"
				type="checkbox"
				class="CHK"
				[(ngModel)]="PrintStudentLatePasses"
				id="PrintStudentLatePasses"
				name="PrintStudentLatePasses"
			/>
			<button
				*ngIf="PrintStudentLatePassesCanOverride == true"
				[disabled]="IsLoading() == true || District_PrintStudentLatePassesCanOverride == false"
				class="btn btn-success NoMargin LockButtonWidth"
				(click)="onTogglePrintStudentLatePassesCanOverride()"
			>
				<i class="fa fa-unlock" aria-hidden="true"></i>
			</button>
			<button
				*ngIf="PrintStudentLatePassesCanOverride == false"
				[disabled]="IsLoading() == true || District_PrintStudentLatePassesCanOverride == false"
				class="btn btn-danger NoMargin LockButtonWidth"
				(click)="onTogglePrintStudentLatePassesCanOverride()"
			>
				<i class="fa fa-lock" aria-hidden="true"></i>
			</button>
			<label *ngIf="District_PrintStudentLatePassesCanOverride == false" class="A411DisabledText">Locked by District</label>
		</div>

		<label for="PrintStudentEntryPasses">Print Student Entry Passes:</label>
		<div class="ButtonGrid">
			<input
				[disabled]="IsLoading() == true || District_PrintStudentEntryPassesCanOverride == false"
				type="checkbox"
				class="CHK"
				[(ngModel)]="PrintStudentEntryPasses"
				id="PrintStudentEntryPasses"
				name="PrintStudentEntryPasses"
			/>
			<button
				*ngIf="PrintStudentEntryPassesCanOverride == true"
				[disabled]="IsLoading() == true || District_PrintStudentEntryPassesCanOverride == false"
				class="btn btn-success NoMargin LockButtonWidth"
				(click)="onTogglePrintStudentEntryPassesCanOverride()"
			>
				<i class="fa fa-unlock" aria-hidden="true"></i>
			</button>
			<button
				*ngIf="PrintStudentEntryPassesCanOverride == false"
				[disabled]="IsLoading() == true || District_PrintStudentEntryPassesCanOverride == false"
				class="btn btn-danger NoMargin LockButtonWidth"
				(click)="onTogglePrintStudentEntryPassesCanOverride()"
			>
				<i class="fa fa-lock" aria-hidden="true"></i>
			</button>
			<label *ngIf="District_PrintStudentEntryPassesCanOverride == false" class="A411DisabledText">Locked by District</label>
		</div>

		<label>Default Printer Align Top:</label>
		<input type="number" class="form-control" [(ngModel)]="Default_PrinterAlignTop" />

		<label>Default Printer Align Left:</label>
		<input type="number" class="form-control" [(ngModel)]="Default_PrinterAlignLeft" />
	</div>

	<!-------------------------------------------------------------------------------------------------------------------------->
	<div class="Divider"></div>
	<!-------------------------------------------------------------------------------------------------------------------------->

	<h4 class="TopMargin">Station Default Settings</h4>
	<div class="MainGrid2Col">
		<label>Default Facility Location</label>
		<select [disabled]="IsLoading() == true" class="form-control" name="Default_FacilityLocationID" [(ngModel)]="Default_FacilityLocationID">
			<option value="" style="display: none"></option>
			<option *ngFor="let o of lstFacilityLocation" [ngValue]="o.ID">{{ o.Desc }}</option>
		</select>

		<label>Default Keyboard Mode:</label>
		<select [disabled]="IsLoading() == true" class="form-control" name="Default_KeyboardMode" [(ngModel)]="Default_KeyboardMode">
			<option value="" style="display: none"></option>
			<option *ngFor="let o of lstKeyboardMode" [ngValue]="o.ID">{{ o.Desc }}</option>
		</select>

		<label>Default Station Mode:</label>
		<div class="ButtonGrid">
			<select
				[disabled]="IsLoading() == true || District_StationModeCanOverride == false"
				class="form-control"
				name="StationMode"
				[(ngModel)]="StationMode"
			>
				<option value="" style="display: none"></option>
				<option *ngFor="let o of lstStationMode" [ngValue]="o.ID">{{ o.Desc }}</option>
			</select>
			<button
				*ngIf="StationModeCanOverride == true"
				[disabled]="IsLoading() == true || District_StationModeCanOverride == false"
				class="btn btn-success NoMargin LockButtonWidth"
				(click)="onToggleStationModeCanOverride()"
			>
				<i class="fa fa-unlock" aria-hidden="true"></i>
			</button>
			<button
				*ngIf="StationModeCanOverride == false"
				[disabled]="IsLoading() == true || District_StationModeCanOverride == false"
				class="btn btn-danger NoMargin LockButtonWidth"
				(click)="onToggleStationModeCanOverride()"
			>
				<i class="fa fa-lock" aria-hidden="true"></i>
			</button>
			<label *ngIf="District_StationModeCanOverride == false" class="A411DisabledText">Locked by District</label>
		</div>

		<div class="OptionLabelDiv">
			<label>Verification Required Message:</label>
			<label class="ExtraLabelText">(For Self Check-In Mode)</label>
		</div>
		<div class="ButtonGrid">
			<input
				[disabled]="IsLoading() == true || District_SelfCheckInVerifyTextCanOverride == false"
				type="text"
				class="form-control TextInput"
				style="min-width: 400px"
				[(ngModel)]="SelfCheckInVerifyText"
			/>
			<button
				*ngIf="SelfCheckInVerifyTextCanOverride == true"
				[disabled]="IsLoading() == true || District_SelfCheckInVerifyTextCanOverride == false"
				class="btn btn-success NoMargin LockButtonWidth"
				(click)="onToggleSelfCheckInVerifyTextCanOverride()"
			>
				<i class="fa fa-unlock" aria-hidden="true"></i>
			</button>
			<button
				*ngIf="SelfCheckInVerifyTextCanOverride == false"
				[disabled]="IsLoading() == true || District_SelfCheckInVerifyTextCanOverride == false"
				class="btn btn-danger NoMargin LockButtonWidth"
				(click)="onToggleSelfCheckInVerifyTextCanOverride()"
			>
				<i class="fa fa-lock" aria-hidden="true"></i>
			</button>
			<label *ngIf="District_SelfCheckInVerifyTextCanOverride == false" class="A411DisabledText">Locked by District</label>
		</div>

		<div *ngIf="IsSU == true" class="OptionLabelDiv">
			<label>Sync Dropdown Minutes (SU-Only):</label>
			<label class="ExtraLabelText"
				>(In 10.16+ the options for Visitor Type, Visit Reason etc. are usually downloaded by the app once per hour for performance.)</label
			>
		</div>
		<div *ngIf="IsSU == true" class="ButtonGrid">
			<input
				[disabled]="IsLoading() == true || District_SyncDropdownMinutesCanOverride == false"
				type="number"
				class="form-control"
				[(ngModel)]="SyncDropdownMinutes"
			/>
			<button
				*ngIf="SyncDropdownMinutesCanOverride == true"
				[disabled]="IsLoading() == true || District_SyncDropdownMinutesCanOverride == false"
				class="btn btn-success NoMargin LockButtonWidth"
				(click)="onToggleSyncDropdownMinutesCanOverride()"
			>
				<i class="fa fa-unlock" aria-hidden="true"></i>
			</button>
			<button
				*ngIf="SyncDropdownMinutesCanOverride == false"
				[disabled]="IsLoading() == true || District_SyncDropdownMinutesCanOverride == false"
				class="btn btn-danger NoMargin LockButtonWidth"
				(click)="onToggleSyncDropdownMinutesCanOverride()"
			>
				<i class="fa fa-lock" aria-hidden="true"></i>
			</button>
			<label *ngIf="District_SyncDropdownMinutesCanOverride == false" class="A411DisabledText">Locked by District</label>
		</div>
	</div>

	<!-------------------------------------------------------------------------------------------------------------------------->
	<div class="Divider"></div>
	<!-------------------------------------------------------------------------------------------------------------------------->
	<h4 class="TopMargin">Internal Alert Button</h4>
	<div class="MainGrid2Col">
		<label for="PanicButtonEnabled">Show Internal Alert Button:</label>
		<div class="ButtonGrid">
			<input
				[disabled]="IsLoading() == true || District_PanicButtonCanOverride == false"
				type="checkbox"
				class="CHK"
				[(ngModel)]="PanicButtonEnabled"
				id="PanicButtonEnabled"
				name="PanicButtonEnabled"
			/>
			<button
				*ngIf="PanicButtonCanOverride == true"
				[disabled]="IsLoading() == true || District_PanicButtonCanOverride == false"
				class="btn btn-success NoMargin LockButtonWidth"
				(click)="onTogglePanicButtonCanOverride()"
			>
				<i class="fa fa-unlock" aria-hidden="true"></i>
			</button>
			<button
				*ngIf="PanicButtonCanOverride == false"
				[disabled]="IsLoading() == true || District_PanicButtonCanOverride == false"
				class="btn btn-danger NoMargin LockButtonWidth"
				(click)="onTogglePanicButtonCanOverride()"
			>
				<i class="fa fa-lock" aria-hidden="true"></i>
			</button>
			<label *ngIf="District_PanicButtonCanOverride == false" class="A411DisabledText">Locked by District</label>
		</div>

		<label for="ConfirmPanicButtonEnabled">Show Confirm Alert Button:</label>
		<div class="ButtonGrid">
			<input
				[disabled]="IsLoading() == true || District_ConfirmPanicButtonCanOverride == false"
				type="checkbox"
				class="CHK"
				[(ngModel)]="ConfirmPanicButtonEnabled"
				id="ConfirmPanicButtonEnabled"
				name="ConfirmPanicButtonEnabled"
			/>
			<button
				*ngIf="ConfirmPanicButtonCanOverride == true"
				[disabled]="IsLoading() == true || District_ConfirmPanicButtonCanOverride == false"
				class="btn btn-success NoMargin LockButtonWidth"
				(click)="onToggleConfirmPanicButtonCanOverride()"
			>
				<i class="fa fa-unlock" aria-hidden="true"></i>
			</button>
			<button
				*ngIf="ConfirmPanicButtonCanOverride == false"
				[disabled]="IsLoading() == true || District_ConfirmPanicButtonCanOverride == false"
				class="btn btn-danger NoMargin LockButtonWidth"
				(click)="onToggleConfirmPanicButtonCanOverride()"
			>
				<i class="fa fa-lock" aria-hidden="true"></i>
			</button>
			<label *ngIf="District_ConfirmPanicButtonCanOverride == false" class="A411DisabledText">Locked by District</label>
		</div>

		<label>Internal Alert Button Text:</label>
		<div class="ButtonGrid">
			<input
				[disabled]="IsLoading() == true || District_PanicButtonTextCanOverride == false"
				type="text"
				class="form-control TextInput"
				[(ngModel)]="PanicButtonText"
			/>
			<button
				*ngIf="PanicButtonTextCanOverride == true"
				[disabled]="IsLoading() == true || District_PanicButtonTextCanOverride == false"
				class="btn btn-success NoMargin LockButtonWidth"
				(click)="onTogglePanicButtonTextCanOverride()"
			>
				<i class="fa fa-unlock" aria-hidden="true"></i>
			</button>
			<button
				*ngIf="PanicButtonTextCanOverride == false"
				[disabled]="IsLoading() == true || District_PanicButtonTextCanOverride == false"
				class="btn btn-danger NoMargin LockButtonWidth"
				(click)="onTogglePanicButtonTextCanOverride()"
			>
				<i class="fa fa-lock" aria-hidden="true"></i>
			</button>
			<label *ngIf="District_PanicButtonTextCanOverride == false" class="A411DisabledText">Locked by District</label>
		</div>

		<label>Confirm Alert Button Text:</label>
		<div class="ButtonGrid">
			<input
				[disabled]="IsLoading() == true || District_ConfirmPanicButtonTextCanOverride == false"
				type="text"
				class="form-control TextInput"
				[(ngModel)]="ConfirmPanicButtonText"
			/>
			<button
				*ngIf="ConfirmPanicButtonTextCanOverride == true"
				[disabled]="IsLoading() == true || District_ConfirmPanicButtonTextCanOverride == false"
				class="btn btn-success NoMargin LockButtonWidth"
				(click)="onToggleConfirmPanicButtonTextCanOverride()"
			>
				<i class="fa fa-unlock" aria-hidden="true"></i>
			</button>
			<button
				*ngIf="ConfirmPanicButtonTextCanOverride == false"
				[disabled]="IsLoading() == true || District_ConfirmPanicButtonTextCanOverride == false"
				class="btn btn-danger NoMargin LockButtonWidth"
				(click)="onToggleConfirmPanicButtonTextCanOverride()"
			>
				<i class="fa fa-lock" aria-hidden="true"></i>
			</button>
			<label *ngIf="District_ConfirmPanicButtonTextCanOverride == false" class="A411DisabledText">Locked by District</label>
		</div>

		<label>Staff App Topic (for alerts):</label>
		<div class="ButtonGrid">
			<select
				[disabled]="IsLoading() == true || District_PanicButtonTopicCanOverride == false"
				class="form-control"
				name="Default_PanicButtonTopicID"
				[(ngModel)]="Default_PanicButtonTopicID"
			>
				<option value="" style="display: none"></option>
				<option *ngFor="let o of lstPanicButtonTopic" [ngValue]="o.ID">{{ o.Desc }}</option>
			</select>

			<button
				*ngIf="PanicButtonTopicCanOverride == true"
				[disabled]="IsLoading() == true || District_PanicButtonTopicCanOverride == false"
				class="btn btn-success NoMargin LockButtonWidth"
				(click)="onTogglePanicButtonTopicCanOverride()"
			>
				<i class="fa fa-unlock" aria-hidden="true"></i>
			</button>
			<button
				*ngIf="PanicButtonTopicCanOverride == false"
				[disabled]="IsLoading() == true || District_PanicButtonTopicCanOverride == false"
				class="btn btn-danger NoMargin LockButtonWidth"
				(click)="onTogglePanicButtonTopicCanOverride()"
			>
				<i class="fa fa-lock" aria-hidden="true"></i>
			</button>
			<label *ngIf="District_PanicButtonTopicCanOverride == false" class="A411DisabledText">Locked by District</label>
		</div>
	</div>
</div>

<div class="Buttons">
	<button class="btn btn-primary" (click)="onUpdate()">Update</button>
	<button class="btn btn-warning" style="margin-left: 5px" (click)="onResetToDistrict()">Reset to District Settings</button>
</div>
